// extracted by mini-css-extract-plugin
export default {"span-link":"span-link--d7d00e","spanLink":"span-link--d7d00e","span-link_pseudo":"span-link_pseudo--46b7a7","spanLink_pseudo":"span-link_pseudo--46b7a7"};